
(function () {
  'use strict';

  var ODSTEP = 16;

  function bezRuchu() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function naglowek() {
    return document.querySelector('store-header') || document.querySelector('.header');
  }

  function wysokoscNaglowka() {
    var el = naglowek();
    if (!el) return 0;
    var r = el.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }

  var PROG_NAGLOWKA = 200;

  var chowanaPamiec = 0;
  function wysokoscChowana() {
    var el = naglowek();
    if (!el) return chowanaPamiec;
    var pasek = el.querySelector('.main-menu__disclosure');
    if (!pasek) return 0;
    var h = Math.round(pasek.getBoundingClientRect().height);
    if (h > 0) chowanaPamiec = h;
    return chowanaPamiec;
  }

  var odsuniecieNaglowka = 0;
  function zapamietajOdsuniecie() {
    if (window.scrollY > 4) return;
    var el = naglowek();
    if (!el) return;
    odsuniecieNaglowka = Math.max(0, Math.round(el.getBoundingClientRect().top));
  }

  function zmiennaMenu() {
    var el = naglowek();
    if (!el) return 0;
    return Math.round(parseFloat(window.getComputedStyle(el).getPropertyValue('--menu-height')) || 0);
  }

  function chowaSie() {
    var chowana = wysokoscChowana();
    return chowana > 0 && Math.abs(zmiennaMenu() - chowana) < 40;
  }

  function przesuniecieTresci() {
    if (!chowaSie()) return 0;
    return wysokoscChowana() - zmiennaMenu();
  }

  function zwinieSie(celY) {
    if (!chowaSie()) return false;
    var teraz = window.scrollY;
    if (celY < PROG_NAGLOWKA) return false;
    if (teraz - celY > 5) return false;
    return celY > teraz;
  }

  function wysokoscPoRuchu(celY) {
    var el = naglowek();
    if (!el) return 0;
    var chowana = wysokoscChowana();
    var h = Math.round(el.getBoundingClientRect().height);
    var rozwinietaH = el.classList.contains('is-out') ? h + chowana : h;
    var hPo = zwinieSie(celY) ? Math.max(0, rozwinietaH - chowana) : rozwinietaH;

    var goraPo = Math.max(-1, odsuniecieNaglowka - celY);
    return Math.max(0, goraPo + hPo);
  }

  function odstepCalkowity(dodatkowy) {
    return ODSTEP + (dodatkowy || 0);
  }

  function ustawFokus(el) {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    el.classList.add('bh-focus-silent');
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  function doCelu(el, dodatkowy, elFokus) {
    if (!el) return;

    var gora = el.getBoundingClientRect().top;
    var odstep = odstepCalkowity(dodatkowy);

    var cel = window.scrollY + gora - wysokoscNaglowka() - odstep;
    var ruchNaglowka = zwinieSie(cel) && !naglowek().classList.contains('is-out');
    cel = window.scrollY + gora + (ruchNaglowka ? przesuniecieTresci() : 0)
      - wysokoscPoRuchu(cel) - odstep;
    cel = Math.max(0, Math.round(cel));

    window.scrollTo({ top: cel, behavior: bezRuchu() ? 'auto' : 'smooth' });
    ustawFokus(elFokus || el);
  }

  function wWidoku(el) {
    if (!el) return true;
    var r = el.getBoundingClientRect();
    return r.top >= wysokoscNaglowka() && r.bottom <= window.innerHeight;
  }

  function gornaWWidoku(el) {
    if (!el) return true;
    var r = el.getBoundingClientRect();
    return r.top >= wysokoscNaglowka() && r.top <= window.innerHeight - ODSTEP;
  }

  var zaplanowane = false;
  var ostatniaWartosc = null;
  function odswiezZmienna() {
    zaplanowane = false;
    var wartosc = wysokoscPoRuchu(window.scrollY + window.innerHeight) + ODSTEP;
    if (wartosc === ostatniaWartosc) return;
    ostatniaWartosc = wartosc;
    document.documentElement.style.setProperty('--bh-sticky-top', wartosc + 'px');
  }

  function zaplanuj() {
    if (zaplanowane) return;
    zaplanowane = true;
    window.requestAnimationFrame(odswiezZmienna);
  }

  function zKotwicyAdresu() {
    var kotwica = (window.location.hash || '').replace('#', '');
    if (!kotwica) return;
    var cel = null;
    try {
      cel = document.getElementById(kotwica);
    } catch (e) {
      cel = null;
    }
    if (!cel) return;
    doCelu(cel);
  }

  zapamietajOdsuniecie();
  odswiezZmienna();
  window.addEventListener('resize', function () { zapamietajOdsuniecie(); zaplanuj(); });
  window.addEventListener('scroll', zaplanuj, { passive: true });
  window.addEventListener('load', function () {
    zapamietajOdsuniecie();
    odswiezZmienna();
    window.setTimeout(zKotwicyAdresu, 120);
  });

  var CZAS_WYSOKOSCI = 220;

  function animujWysokosc(el, zmiana, poZakonczeniu) {
    if (!el || bezRuchu()) {
      zmiana();
      if (typeof poZakonczeniu === 'function') poZakonczeniu();
      return;
    }

    var stan = el.__bhWysokosc || null;
    var oczekujace = stan ? stan.oczekujace : [];
    if (typeof poZakonczeniu === 'function') oczekujace.push(poZakonczeniu);

    var przed = Math.round(el.getBoundingClientRect().height);

    if (stan) {
      el.removeEventListener('transitionend', stan.posprzataj);
      window.clearTimeout(stan.awaryjny);
      el.__bhWysokosc = null;
    }

    zmiana();

    el.style.transition = 'none';
    el.style.height = '';
    el.style.overflow = '';
    var po = Math.round(el.getBoundingClientRect().height);

    var domknij = function () {
      el.style.transition = '';
      el.style.height = '';
      el.style.overflow = '';
      var lista = oczekujace.slice();
      oczekujace.length = 0;
      for (var i = 0; i < lista.length; i += 1) lista[i]();
    };

    if (Math.abs(po - przed) < 2) {
      domknij();
      return;
    }

    el.style.height = przed + 'px';
    el.style.overflow = 'hidden';
    void el.offsetHeight;
    el.style.transition = 'height ' + CZAS_WYSOKOSCI + 'ms ease';
    el.style.height = po + 'px';

    var posprzataj = function (ev) {
      if (ev && ev.propertyName && ev.propertyName !== 'height') return;
      el.removeEventListener('transitionend', posprzataj);
      window.clearTimeout(awaryjny);
      el.__bhWysokosc = null;
      domknij();
    };
    var awaryjny = window.setTimeout(posprzataj, CZAS_WYSOKOSCI + 120);
    el.addEventListener('transitionend', posprzataj);
    el.__bhWysokosc = { posprzataj: posprzataj, awaryjny: awaryjny, oczekujace: oczekujace };
  }

  function doPoziomo(tor, el, odstep) {
    if (!tor || !el) return;
    var margines = typeof odstep === 'number' ? odstep : 16;
    var rt = tor.getBoundingClientRect();
    var re = el.getBoundingClientRect();
    var cel = tor.scrollLeft;

    if (re.width > rt.width - margines * 2) margines = 0;

    if (re.left < rt.left + margines) cel = tor.scrollLeft + (re.left - rt.left) - margines;
    else if (re.right > rt.right - margines) cel = tor.scrollLeft + (re.right - rt.right) + margines;
    else return;

    var max = Math.max(0, tor.scrollWidth - tor.clientWidth);
    cel = Math.max(0, Math.min(cel, max));
    if (Math.abs(cel - tor.scrollLeft) < 1) return;
    tor.scrollTo({ left: cel, behavior: bezRuchu() ? 'auto' : 'smooth' });
  }

  function doElementuToru(tor, el) {
    if (!tor || !el) return;
    var rt = tor.getBoundingClientRect();
    var re = el.getBoundingClientRect();
    var cel = tor.scrollLeft + (re.left - rt.left);
    var wyrownanie = window.getComputedStyle(el).scrollSnapAlign || '';
    if (wyrownanie.indexOf('center') !== -1) cel -= (rt.width - re.width) / 2;
    else cel -= parseFloat(window.getComputedStyle(tor).scrollPaddingLeft) || 0;
    var max = Math.max(0, tor.scrollWidth - tor.clientWidth);
    cel = Math.max(0, Math.min(cel, max));
    tor.scrollTo({ left: cel, behavior: bezRuchu() ? 'auto' : 'smooth' });
  }

  window.BramoweHomeScroll = {
    doCelu: doCelu,
    doPoziomo: doPoziomo,
    doElementuToru: doElementuToru,
    animujWysokosc: animujWysokosc,
    wWidoku: wWidoku,
    gornaWWidoku: gornaWWidoku,
    wysokoscNaglowka: wysokoscNaglowka,
    wysokoscPoRuchu: wysokoscPoRuchu,
    zKotwicyAdresu: zKotwicyAdresu,
  };
}());
